<mat-toolbar class="topbar topbar-xl m-auto h-auto p-y-8">
  <div class="container full-width p-xs-6">
    <a [routerLink]="['/landing']">
      <img class="d-none d-sm-block" [src]="tenantService.getDesktopLogo()" />
      <img
        class="d-block d-sm-none"
        height="26"
        src="/assets/images/svgs/remitcircle_logo_mobile.svg"
      />
    </a>
    <span class="flex-1-auto"></span>
    <div class="d-flex">
      <a
        mat-flat-button
        color="primary"
        class="sm"
        href="/authentication/signup"
        >Sign Up</a
      >
      <a
        mat-flat-button
        color="secondary"
        class="m-l-10 sm"
        href="/authentication/login"
        >Sign in</a
      >
    </div>
  </div>
</mat-toolbar>
<mat-card class="no-shadow r-0 p-y-32 m-b-0">
  <mat-card-title class="text-center f-s-24 f-w-600 text-primary text-uppercase"
    >Privacy Policy</mat-card-title
  >
  <mat-card-content>
    <div class="container">
      <label>Last Updated: <b>06.02.2025</b></label>
      <p>
        We, RemitCircle Inc., incorporated under the laws of India, including
        our affiliated entities, group companies or permitted assigns, (<strong
          >“Company”, “we” or “us”</strong
        >) recognize that user’s (<strong>“you” or “user”</strong>) privacy is
        very important and it is our endeavour to protect your data and privacy
        in compliance with applicable laws and as per the details outlined in
        this Privacy Policy (<strong>“Privacy Policy”</strong>). Privacy Policy
        describes Company’s policies and procedures relating to collection, use,
        processing and disclosure of your information pursuant to your use of
        our website
        <a [routerLink]="['https://remitcircle.com']"
          >https://remitcircle.com</a
        >
        desktop or mobile application, any software application and related
        applications (collectively, the <strong>“Online Platform”</strong>).
        This Privacy Policy is part of and is to be read along with the Terms of
        Service (<strong>“TOS”</strong>) document as available on our Online
        Platform.
      </p>
      <p>
        For the purposes of this Privacy Notice, “Personal Data” means data
        relating to you that is directly or indirectly identifiable, having
        regard to any characteristic, trait, attribute or any other feature of
        your identity or any combination of such features with any other
        information. Personal Data does not mean information that is freely
        available or accessible in public domain or furnished under the Right to
        Information Act, 2005 or any other law for the time being in force.
      </p>
      <p>
        We advise you to read this Privacy Policy and TOS before using our
        Online Platforms, using any of our services or submitting any personal
        data. By using the Online Platforms, it shall be deemed that you are
        expressly consenting to be bound by the terms and conditions described
        in this Privacy Policy and TOS.
      </p>
      <p>
        Please note that our services offered through the Online Platform are
        not intended for minors below the age of 18 years and individuals who
        are incapacitated because of disability. We do not knowingly collect
        data relating to minors and such persons with disability.
      </p>
      <h6>A.INTRODUCTION</h6>
      <p>
        1.We reserve our right to change and update this Privacy Policy from
        time to time, therefore, you should regularly check for any changes in
        our Privacy Policy. We will notify all users of any material changes, to
        the extent feasible, to this Privacy Policy and the Privacy Policy
        document will also signify the date of Last update for user’s
        convenience. Your continued access to or use of our Online Platform and
        services after the date of the update in Privacy Policy constitutes your
        acknowledgment and agreement that you have read, understood and accepted
        the terms of the updated Privacy Policy. If you do not agree to the
        updated Privacy Policy, you must stop accessing or using our Online
        Platform and/or our Services.
      </p>
      <h6>B.INFORMATION WE COLLECT</h6>
      <p>
        2.We may collect and process the range following data about you
        depending on the nature of and purposes of rendering Our services:
      </p>
      <p>
        a) You may be required to give us sensitive personal data about the
        ultimate beneficial owners and other relevant stakeholders of the entity
        before, during or after creating an Account, or while corresponding with
        us through any means of communications. Sensitive personal data that you
        will voluntarily provide us may include information such as name,
        photograph, postal address, e-mail address, phone number, details/copy
        of Govt. Issued National Identity documents (i.e. Passport, Aadhaar Card
        etc.), details/copy of documents used as proof of address (i.e. Driving
        licence, utility bills, bank passbook etc.), details/copy of your Tax
        Identification Details (i.e. Permanent Account Number - PAN card) and
        other identification documents.
      </p>
      <p>
        b) Your financial and credit card information, details of your Bank
        Account, location details or other information requested by us to detect
        and protect against frauds and similar criminal activity and such other
        information required by us from time to time for providing the Services.
      </p>
      <p>
        c)Details of all your transactions or activities performed and carried
        out on or through our Online Platform.
      </p>
      <p>
        d)Technical information, including the Internet protocol (IP) address
        used to connect your device to the Internet, your login information,
        browser type and version, time zone setting, browser plug-in types and
        versions, operating system and platform, material or information that
        you viewed or searched for; page response times, download errors, length
        of visits to certain pages, page interaction information (such as
        scrolling, clicks, and mouse-hovers), and methods used to browse away
        from the page and any phone number used to call our customer service
        number.
      </p>
      <p>
        e)<strong>Cookies:</strong> Our Online Platform uses Cookies and
        tracking technology in order to distinguish you from other Users of our
        Online Platform and enables us to serve you better and provide you a
        customised and personalised user experience. Cookie and tracking
        information collected by us may be shared with third-parties which
        directly support our services and are involved in development/
        improvement of our Online Platform.
      </p>
      <h6>C.USE OF INFORMATION</h6>
      <p>
        3.The Information that we collect from or about you may be used and/or
        processed:
      </p>
      <ul>
        <li>
          to verify, maintain, update and retain your personal details and
          details relating to your identity, address, financial information and
          other aspects as may be required as per our Company’s policy or to
          comply with applicable laws and regulations;
        </li>
        <li>
          to facilitate and provide the services offered through the Online
          Platform;
        </li>
        <li>
          to inform you of our products, services, promotions, offers, surveys
          and events which may be of interest to you;
        </li>
        <li>
          to carry out update, upgrade, maintenance, customization and other
          changes in our products and services to serve you better;
        </li>
        <li>
          to provide you with the information and Services, that you request
          from us;
        </li>
        <li>
          to enhance the security and user experience of our Online Platform;
        </li>
        <li>
          To track and remember information and details relating to the
          transactions executed by you on or through our Online Platform;
        </li>
        <li>
          to prevent and identify suspicious / other illegal transactions in
          order to mitigate risks relating to money laundering and other illegal
          activities;
        </li>
        <li>
          to provide you, or permit selected Third Parties to provide you, with
          information about Services we feel may interest you or for the
          purposes of verification and authentication of your identification
          documents;
        </li>
        <li>
          to send you Service related notices or emails and other non-essential
          promotional material (you will be provided an option to unsubscribe to
          such email or other communications);
        </li>
        <li>
          for KYC verification, ourselves or through a selected Third Party, of
          the details of Tax Identification and other Identification documents
          provided by you. You understand that in order to verify that such
          information belongs to you, we may send you a verification
          email/one-time password.
        </li>
      </ul>
      <h6>D.SHARING OF INFORMATION</h6>
      <h6><u>Third-Party Sharing</u></h6>
      <p>
        4.We reserve the right to share any Information that we collect from
        you, as prescribed above with third parties in the course of Our
        business. Consistent with applicable legal requirements, we take
        commercially reasonable steps to require third parties to adequately
        safeguard your Personal Data.
      </p>
      <p>
        5.Our services may include links to other websites or applications when
        you visit our Platform. Such websites or applications are governed by
        their respective privacy policies, which are beyond our control. Once
        you leave our servers (you can tell where you are by checking the URL in
        the location bar on your browser or on the m-site you are redirected
        to), use of any Personal Information that you provide on these websites
        or applications is governed by the privacy policy of the operator of the
        application/website, you are visiting. That policy may differ from ours
        and you are requested to review those policies or seek access to the
        policies from the domain owner before proceeding to use those
        applications or websites. We do not accept any responsibility or
        liability for usage of your Personal Information by these third parties
        or their policies.
      </p>
      <p>
        6.We further reserve the right to share your personal data to any third
        party when we are under obligation to share such information under
        applicable laws or under the order of any competent authority/court. We
        may also disclose and share your personal data with third parties to
        detect, prevent or investigate any actual or potential occurrence of
        identity theft, fraud, money laundering, abuse of Services and other
        illegal acts.
      </p>
      <p>
        7.We may share your personal data with selected business partners,
        service providers and third parties including Banks, payment processing
        companies, KYC verification service providers and third party virtual
        digital asset service providers (“Third Parties”).
      </p>
      <h6><u>Cross-border transfer/processing </u></h6>
      <p>
        8.Your personal data may be processed and stored in a foreign country or
        countries. In this regard, we will take such necessary measures to
        ensure that such overseas recipients are bound by legally enforceable
        obligations to provide at least the same standard of protection to your
        personal data that we are obliged to under applicable laws. However, in
        case of such processing or transfer, the governments, courts, law
        enforcement, or regulatory agencies of that country or those countries
        may be able to obtain access to your personal data under relevant
        foreign laws.
      </p>
      <h6><u>Non-Personal Data</u></h6>
      <p>
        9.The Company reserves the right to share current and historical volume
        of transactions, market trends, historical volume data, estimated and
        actual transaction volumes and other aggregate data and information
        relating to the user behaviour pattern or trend of transaction executed
        on our Online Platform. This information shall be shared in a
        non-personal format and no person shall be identifiable by processing
        such information.
      </p>
      <h6>E.YOUR CONSENT</h6>
      <p>
        11.By using any of the Online Platform, you agree and consent to the
        collection and use of information collected to the extent and in the
        manner described above and in accordance with this Privacy Policy. You
        also agree and consent to any changes made to this Privacy Policy in due
        course and without notice. If you do not agree with the terms and
        conditions of this Privacy Policy, please do not provide any information
        to us. If you refuse or withdraw your consent, or if you choose not to
        provide us with any information as required by us, we may not be able to
        provide you with the Services that are being offered through the Online
        Platform.
      </p>
      <p>
        12.You also agree that all your data and/or information shared with us
        is accurate, correct and complete, at all times. You understand that you
        must promptly inform us of any changes to your data and/or information
        which may impact your use of our Services.
      </p>
      <h6>F.WITHDRAWAL OF CONSENT</h6>
      <p>
        13.You may disable or delete your account maintained with us at any
        point of time by making and completing verification of such request to
        us, through Our website, subject to the applicable terms and conditions.
        With this, we will no longer share your Personal Data with any
        Third-Parties or process it for any purpose save as otherwise required
        under applicable law. Specifically, we retain your Personal Data as long
        as the purpose for its usage exists, after which the same is disposed of
        by us unless retention is required for compliance with any Applicable
        Law.
      </p>
      <h6>G.ASSIGNMENT</h6>
      <p>
        14.We may assign, novate, or transfer any or all rights and obligations
        that accrued in our favour under the Privacy Policy, at our sole
        discretion, to our subsidiaries, affiliated entities, or any selected
        Third Party to offer you a full suite of services globally through our
        subsidiaries or affiliates.
      </p>
      <h6>SECURITY PRACTICE</h6>
      <p>
        15.Your Personal Data is accessible only by our authorized employees and
        selected Third Parties, and is otherwise kept secure.
      </p>
      <p>
        16.We have in place appropriate technical and security measures to
        prevent unlawful access to or accidental loss of Personal Data collected
        by us. We have taken the following steps to ensure data security:
      </p>
      <ul>
        <li>
          All the user information can only be accessed by authorized users;
        </li>
        <li>
          Users need to authenticate themselves with a username-password
          combination; and
        </li>
        <li>
          All data is hosted on the servers of Amazon Web Services. For more
          information, please refer to the details of the security standards and
          compliance policies of the hosting service provider.
        </li>
      </ul>
      <p>
        17.The transmission of information via the internet is not completely
        secure. Although we will do our best to protect your Personal Data, we
        cannot guarantee, give no warranties, and shall not be liable for breach
        of the security of your data transmitted through the Online Platform due
        to malicious attacks, errors, commission or omissions not willfully
        initiated by us. Any transmission is at your own risk. Once we have
        received your information, we will use reasonable standards and
        practices to strict physical, electronic, and procedural safeguards to
        try to prevent unauthorised access.
      </p>

      <h6>I.DATA RETENTION</h6>
      <p>
        18.We retain Personal Data provided by you for as long as your Account
        is active, unless you specifically withdraw consent and stop using Our
        services. We shall subsequently retain your Personal Data as required to
        comply with Applicable Laws, for resolution of disputes, for the purpose
        of investigations or ongoing prosecutions or in case of any suspicious/
        illegal transactions, for enforcement of any agreements, and/or as
        necessitated under applicable laws.
      </p>
      <p>
        19.We make no warranties and shall not be liable regarding
        non-availability or non-retention of any Personal Data provided by you
        beyond the deletion of your Account.
      </p>
      <h6>J.YOUR RIGHTS</h6>
      <p>
        20.<em>The right to access –</em> You have the right to request our
        Company for copies of your personal data including summary of personal
        data processed or identities of all other Data Fiduciaries and Data
        Processors with whom the personal data has been shared, etc. We may
        charge you a small fee for this service.
      </p>
      <p>
        21. <em>The right to rectification –</em> You have the right to request
        that our Company correct any information you believe is inaccurate. You
        also have the right to request our Company to complete the information
        you believe is incomplete.
      </p>
      <p>
        22.<em>The right to erasure –</em> You have the right to request that
        our Company erase your Personal Data, under certain conditions.
      </p>
      <p>
        23.<em>The right to restrict processing –</em> You have the right to
        request that our Company restrict the processing of your Personal Data,
        under certain conditions.
      </p>
      <p>
        24.<em>The right to object to processing –</em> You have the right to
        object to our Company’s processing of your Personal Data, under certain
        conditions.
      </p>
      <p>
        25.<em>The right to nominate-</em> You may also nominate any individual
        who shall be authorized to take actions on your behalf in case of your
        death or incapacitation.
      </p>
      <p>
        You may exercise any or all of the above-mentioned rights by contacting
        Our Data Protection Officer. If you make a request, we have one month to
        respond to you.
      </p>
      <h6>K.CONTACT INFORMATION</h6>
      <p>
        27.The data fiduciary responsible for your personal data is Purple Pixel
        Private Limited. In case you have any queries, please write to our Data
        Protection Officer at
        <a href="mailto:admin@remitcircle.com">admin&#64;remitcircle.com</a>
      </p>
    </div>
  </mat-card-content>
</mat-card>
